import { IShiftProgram } from '../types/operations.types'

export const MOCK_SHIFT_PROGRAMS: IShiftProgram[] = [
  {
    id: 'sp-001',
    name: 'Daily Site Cleaning',
    siteId: 1,
    siteName: 'Site Alpha',
    departmentId: 5,
    departmentName: 'Camp Services',
    teamIds: [1, 2],
    teamNames: ['Cleaning Team A', 'Cleaning Team B'],
    shiftIds: [1, 2],
    shiftNames: ['Day Shift (06:00-18:00)', 'Night Shift (18:00-06:00)'],
    status: 'Active',
    tasksPerShift: 12,
    workersNeeded: 8,
    lastRun: '2026-03-26T06:00:00Z',
    nextRun: '2026-03-26T18:00:00Z',
    taskBindings: [],
  },
  {
    id: 'sp-002',
    name: 'Security Patrol Schedule',
    siteId: 1,
    siteName: 'Site Alpha',
    departmentId: 6,
    departmentName: 'Security',
    teamIds: [3],
    teamNames: ['Security Team Alpha'],
    shiftIds: [1, 2],
    shiftNames: ['Day Shift (06:00-18:00)', 'Night Shift (18:00-06:00)'],
    status: 'Active',
    tasksPerShift: 8,
    workersNeeded: 4,
    lastRun: '2026-03-26T06:00:00Z',
    nextRun: '2026-03-26T18:00:00Z',
    taskBindings: [],
  },
  {
    id: 'sp-003',
    name: 'Equipment Inspection Round',
    siteId: 1,
    siteName: 'Site Alpha',
    departmentId: 4,
    departmentName: 'Maintenance',
    teamIds: [4],
    teamNames: ['Inspection Crew'],
    shiftIds: [1],
    shiftNames: ['Day Shift (06:00-18:00)'],
    status: 'Active',
    tasksPerShift: 6,
    workersNeeded: 3,
    lastRun: '2026-03-26T06:00:00Z',
    nextRun: '2026-03-27T06:00:00Z',
    taskBindings: [],
  },
  {
    id: 'sp-004',
    name: 'Operator Safety Rounds',
    siteId: 2,
    siteName: 'Site Beta',
    departmentId: 1,
    departmentName: 'Operations',
    teamIds: [5],
    teamNames: ['Safety Team'],
    shiftIds: [1, 2],
    shiftNames: ['Day Shift (06:00-18:00)', 'Night Shift (18:00-06:00)'],
    status: 'Paused',
    tasksPerShift: 4,
    workersNeeded: 2,
    lastRun: '2026-03-20T06:00:00Z',
    taskBindings: [],
  },
]
